import React, { useState } from 'react';
import {
  Col, Form, Row, Spinner,
} from 'react-bootstrap';
import { dataService } from '../../services/DataService';
import hashFileName from '../../utils/hashFileName';

interface ImageProps {
  formik: Record<string, any>,
}

export default function FormImage({
  formik,
}: ImageProps) {
  const [uploading, setUploading] = useState({ de: false, fr: false, it: false });
  const [previews, setPreviews] = useState({ de: '', fr: '', it: '' });

  const handleFileChange = async (
    file: File | null,
    locale: 'de' | 'fr' | 'it',
  ) => {
    if (!file) {
      setPreviews((prev) => ({ ...prev, [locale]: '' }));
      return;
    }

    // Set preview immediately
    const objectUrl = URL.createObjectURL(file);
    setPreviews((prev) => ({ ...prev, [locale]: objectUrl }));

    // Upload file with hash-based naming
    setUploading((prev) => ({ ...prev, [locale]: true }));
    try {
      const hashedName = await hashFileName(file);
      const questionId = formik.values.id || 'temp';
      const uploadPath = `questions/${questionId}/images/${locale}/${hashedName}`;
      const uploadRes = await dataService.uploadFile(file, uploadPath);

      // Update formik with uploaded URL
      const fieldName = locale === 'de' ? 'imageSrc' : `imageSrc_${locale}`;
      formik.setFieldValue(fieldName, uploadRes.url);
    } catch (error) {
      console.error(`Image upload failed for ${locale}:`, error);
      // Keep preview but don't update formik value on error
    } finally {
      setUploading((prev) => ({ ...prev, [locale]: false }));
    }
  };

  return (
    <>
      <h3>Bild einfügen</h3>
      <Row className="mb-3">
        <Col>
          <Form.Group className="mb-3" controlId="imageSrc">
            <Form.Label>Bildquelle (DE) - Bestehender Pfad oder Upload</Form.Label>
            <Form.Control
              type="text"
              placeholder="Image source"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.imageSrc}
              className="mb-2"
            />
            <Form.Control
              type="file"
              accept="image/*"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const file = e.target.files?.[0] || null;
                handleFileChange(file, 'de');
              }}
            />
            {uploading.de && (
              <div className="mt-2 small text-muted">
                <Spinner animation="border" size="sm" className="me-2" />
                Hochladen...
              </div>
            )}
            {previews.de && (
              <div className="mt-2">
                <img src={previews.de} alt="Vorschau DE" style={{ maxWidth: '200px', height: 'auto' }} />
              </div>
            )}
          </Form.Group>
          <Form.Group className="mb-3" controlId="imageSrc_fr">
            <Form.Label>Source de l&apos;image (FR) - Chemin existant ou télécharger</Form.Label>
            <Form.Control
              type="text"
              placeholder="Source de l'image"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.imageSrc_fr}
              className="mb-2"
            />
            <Form.Control
              type="file"
              accept="image/*"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const file = e.target.files?.[0] || null;
                handleFileChange(file, 'fr');
              }}
            />
            {uploading.fr && (
              <div className="mt-2 small text-muted">
                <Spinner animation="border" size="sm" className="me-2" />
                Téléchargement...
              </div>
            )}
            {previews.fr && (
              <div className="mt-2">
                <img src={previews.fr} alt="Aperçu FR" style={{ maxWidth: '200px', height: 'auto' }} />
              </div>
            )}
          </Form.Group>
          <Form.Group className="mb-3" controlId="imageSrc_it">
            <Form.Label>Fonte immagine (IT) - Percorso esistente o carica</Form.Label>
            <Form.Control
              type="text"
              placeholder="Fonte immagine"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.imageSrc_it}
              className="mb-2"
            />
            <Form.Control
              type="file"
              accept="image/*"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const file = e.target.files?.[0] || null;
                handleFileChange(file, 'it');
              }}
            />
            {uploading.it && (
              <div className="mt-2 small text-muted">
                <Spinner animation="border" size="sm" className="me-2" />
                Caricamento...
              </div>
            )}
            {previews.it && (
              <div className="mt-2">
                <img src={previews.it} alt="Anteprima IT" style={{ maxWidth: '200px', height: 'auto' }} />
              </div>
            )}
          </Form.Group>
        </Col>
      </Row>
    </>
  );
}
